const baseModel = {
  path: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/3d-tiles-merged/2024/tileset.json`,
  adjustHeight: -37,
};



export default baseModel;
